module.exports = __webpack_public_path__ + "static/media/tick-blue.c90c68a3.svg";